import * as React from 'react';
import { ISimpleMobileMenuProps, ISimpleMobileMenuState } from './SimpleMobileMenu.types';
import { ButtonLink, MainMenuItem } from '../MainMenu/MainMenu.types';
import { Icon } from '../Icon/icon';

/**
 * Mobile menu with breadcrumbs
 */
export class SimpleMobileMenu extends React.Component<ISimpleMobileMenuProps, ISimpleMobileMenuState> {
  private itemsToShow: number[];
  constructor(props: ISimpleMobileMenuProps) {
    super(props);
    this.state = {
      menuIsOpen: false,
      searchIsOpen: false,
      searchIsReadyToFocus: false,
      currentOpenMenuId: null,
      toggle: false,
      itemsToShow: [],
      childSelected: false,
    };
    this.itemsToShow = [];
  }

  componentDidMount() {
    var result = [];
    var parentIds = this.findSelectedItems(this.props.treeNodes.Children, result);
    this.itemsToShow = parentIds;

    if (this.props.isCampaignPage) {
      this.props.treeNodes.Children.forEach((child) => {
        if (child.Selected || child.PathSelected) {
          this.setState({
            childSelected: true,
          });
        }
      });
    }

    this.setState({
      itemsToShow: this.itemsToShow,
    });
  }

  findObject = (arr) => {
    var result;
    for (let i = 0; i < arr.length; i++) {
      if ((arr[i].PageTreeDepth === 3 || arr[i].PageTreeDepth === 4) && arr[i].Selected) {
        result = arr[i];
        break;
      }
      if (arr[i].Children) {
        result = this.findObject(arr[i].Children);
        if (result) break;
      }
    }
    return result;
  };
  findSelectedItems = (arr, result) => {
    for (let i = 0; i < arr.length; i++) {
      if (arr[i].PathSelected || (arr[i].Selected && arr[i].PageTreeDepth > 2)) {
        result.push(arr[i].Id);
      }
      if (arr[i].Children) {
        result = this.findSelectedItems(arr[i].Children, result);
      }
    }
    return result;
  };
  setSearchOpenState = (): void => {
    this.setState((prevState) => ({
      searchIsOpen: !prevState.searchIsOpen,
    }));
  };
  renderSubMenuItem = (subItem: MainMenuItem, index: number) => {
    let otherAttr: React.HTMLAttributes<any> = {};
    let isInPagePath = this.props.currentPageAncestorsIds.indexOf(subItem.Id) != -1;
    if (subItem.Id == this.props.currentPageId) {
      otherAttr['aria-current'] = 'page';
    } else {
      otherAttr = {};
    }
    return (
      <li
        className={`simple-mobile-menu__subitem simple-mobile-menu--level3 ${
          subItem.Id == this.props.currentPageId || subItem.PathSelected || isInPagePath
            ? 'simple-mobile-menu__level2-active simple-mobile-menu__level3-active'
            : ''
        }`}
        key={'subitem' + index}>
        <a className={``} {...otherAttr} href={subItem.Url}>
          {subItem.MenuTitle ? subItem.MenuTitle : subItem.Name}
        </a>
      </li>
    );
  };
  renderSubItems = (item: MainMenuItem, index: number) => {
    let otherAttr: React.HTMLAttributes<any> = {};
    let showItems = this.contains(this.state.itemsToShow, item.Id);
    if (item.Id == this.props.currentPageId) {
      otherAttr['aria-current'] = 'page';
    } else {
      otherAttr = {};
    }
    return (
      <li key={'item' + index} className={`simple-mobile-menu__subitem simple-mobile-menu--level2`}>
        <div
          className={`d-flex justify-content-between align-items-center ${
            item.Selected && !item.PathSelected ? 'simple-mobile-menu__level2-active' : ''
          }`}>
          {item.PageAsHeadingInMegaMenu ? (
            <span {...otherAttr}> {item.MenuTitle ? item.MenuTitle : item.Name}</span>
          ) : (
            <a {...otherAttr} href={item.Url} className="">
              {item.MenuTitle ? item.MenuTitle : item.Name}
            </a>
          )}
          {item.HasChildren && (
            <button
              onClick={this.toggleSubItems}
              id={item.Id.toString()}
              aria-expanded={showItems}
              aria-label={item.Name}
              aria-controls={'subitemslevel3' + item.Id}
              className="simple-mobile-menu__button">
              <Icon
                className={`simple-mobile-menu__arrow simple-mobile-menu--arrow-level2 ${
                  showItems ? 'simple-mobile-menu--up-arrow' : ''
                }`}
                iconType="fontawesome/chevron-left"
              />
            </button>
          )}
        </div>
        <ul className={`${showItems ? 'd-block' : 'd-none'}`} id={'subitemslevel3' + item.Id}>
          {item.MegaMenuOverrideLinks && item.MegaMenuOverrideLinks.length > 0
            ? item.MegaMenuOverrideLinks.map(this.renderSubMenuItem)
            : item.Children.map(this.renderSubMenuItem)}
          {item.MegaMenuShowAllLinkText && (
            <li>
              <a className="simple-mobile-menu__showalltext" href={item.Url}>
                {item.MegaMenuShowAllLinkText}
              </a>
            </li>
          )}
        </ul>
      </li>
    );
  };
  renderMegaMenuButtonLinks = (buttonLink: ButtonLink, index: number) => {
    return (
      <li className="simple-mobile-menu__buttonlink-item" key={index}>
        <a href={buttonLink.Href} target={buttonLink.Target} title={buttonLink.Title} className="mega-menu__buttonLink">
          <div className="mega-menu__buttonLinkText">
            <span> {buttonLink.Text}</span>
          </div>
          <div className="mega-menu__buttonLinkIcon">
            <Icon className="mega-menu__icon" iconType="fontawesome/chevron-left" />
          </div>
        </a>
      </li>
    );
  };
  toggleSubItems = (e) => {
    var currentTarget = e.currentTarget;
    var currentId = parseInt(currentTarget.id);
    if (this.contains(this.itemsToShow, currentId)) {
      this.removeItemOnce(this.itemsToShow, currentId);
    } else {
      this.itemsToShow.push(currentId);
    }
    this.setState({
      itemsToShow: this.itemsToShow,
      currentOpenMenuId: currentId + 'button',
    });
  };
  contains = (a, obj) => {
    var i = a.length;
    while (i--) {
      if (a[i] === obj) {
        return true;
      }
    }
    return false;
  };
  removeItemOnce = (arr, value) => {
    var index = arr.indexOf(value);
    if (index > -1) {
      arr.splice(index, 1);
    }
    return arr;
  };
  render() {
    return (
      <nav className="simple-mobile-menu" aria-label="Hierarkisk navigationsmeny för hela webbplatsen">
        <ul className="simple-mobile-menu__list">
          {/* //Show campaign startpage in mobilemenu */}
          {this.props.isCampaignPage && (
            <li
              className={`simple-mobile-menu__level1 ${
                !this.state.childSelected ? 'simple-mobile-menu__selected' : ''
              }`}>
              <div className="simple-mobile-menu__mainitems d-flex justify-content-between align-items-center">
                <a href={this.props.treeNodes.Url}>{this.props.treeNodes.Name}</a>
              </div>
            </li>
          )}
          {this.props.treeNodes.Children.map((child, i) => {
            let showItems = this.contains(this.state.itemsToShow, child.Id);
            return (
              <li
                key={i}
                className={`simple-mobile-menu__level1 ${showItems ? 'simple-mobile-menu__open' : ''} ${
                  child.Selected || child.PathSelected ? 'simple-mobile-menu__selected' : ''
                } ${child.PathSelected ? 'path' : ''}`}>
                <div className="simple-mobile-menu__mainitems d-flex justify-content-between align-items-center">
                  <a href={child.Url}>{child.MenuTitle ? child.MenuTitle : child.Name}</a>
                  {child.Children.length > 0 && (
                    <button
                      onClick={this.toggleSubItems}
                      id={child.Id.toString() + 'button'}
                      aria-expanded={showItems}
                      aria-label={child.Name}
                      aria-controls={'subitemsmobile' + child.Id}
                      className="simple-mobile-menu__button">
                      <Icon
                        className={`simple-mobile-menu__arrow ${showItems ? 'simple-mobile-menu--up-arrow' : ''}`}
                        iconType="fontawesome/chevron-left"
                      />
                    </button>
                  )}
                </div>
                {child.Children.length > 0 && (
                  <ul
                    key={i}
                    id={'subitemsmobile' + child.Id}
                    data-id={child.Id}
                    className={`${showItems ? 'd-flex' : 'd-none'} flex-wrap`}>
                    {child.Children.map(this.renderSubItems)}
                    {(this.state.currentOpenMenuId == child.Id + 'button' || showItems) &&
                      child.MegaMenuButtonLinks &&
                      child.MegaMenuButtonLinks.length > 0 && (
                        <div className="col-12 mega-menu__buttonLinkItem">
                          {child.HeadingMegaMenuLinks && (
                            <h3 className="mega-menu__buttonLinkHeading mega-menu__content--border ">
                              {child.HeadingMegaMenuLinks}
                            </h3>
                          )}
                          <ul className="d-flex flex-wrap mega-menu__buttonLinkWrapper">
                            {child.MegaMenuButtonLinks.map(this.renderMegaMenuButtonLinks)}
                          </ul>
                        </div>
                      )}
                  </ul>
                )}
              </li>
            );
          })}
        </ul>
      </nav>
    );
  }
}
